/* ============================================================
   sl-facets.js — v2
   Facettes custom Silamp.

   - "Voir plus / Voir moins" par groupe
   - Recherche intra-facette (listes longues) + etat vide
   - Etat visuel immediat au clic, sans attendre le retour AJAX
   - Events GA4 (dataLayer) pour l'analyse de pertinence

   Tout est en delegation sur document : le contenu de <facet-filters>
   est integralement re-rendu par le theme (Section Rendering API) a
   chaque filtrage, donc aucun handler pose sur un noeud interne ne
   survivrait. La delegation, elle, survit sans re-binding.
   ============================================================ */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function facetRoot(el) {
    return el && el.closest ? el.closest('facet-filters.sl-facets') : null;
  }

  function collectionHandle(el) {
    var root = facetRoot(el);
    return (root && root.getAttribute('data-collection')) || '';
  }

  function groupKey(el) {
    var g = el && el.closest ? el.closest('.sl-facet') : null;
    return g ? g.getAttribute('data-sl-facet') || '' : '';
  }

  function push(payload) {
    try {
      window.dataLayer.push(payload);
    } catch (e) {
      /* l'analytics ne doit jamais casser le filtrage */
    }
  }

  /* ============================================================
     Tri numerique des valeurs de facette
     ------------------------------------------------------------
     Liquid ne sait pas trier sur une cle calculee. Or l'ordre natif
     S&D est l'ordre de saisie, et un tri alphabetique classerait
     "100 a 200W" avant "20 a 30W". On trie donc ici, sur le premier
     nombre trouve dans le libelle :
       "10 a 20W"        ->  10
       "1 000 a 2000 lm" ->  1000   (separateurs de milliers ignores)
       "12V"             ->  12
       "Selon l'ampoule" ->  pas de nombre : rejete en fin de liste,
                             dans son ordre d'origine
     Les valeurs epinglees sont sorties en tete par Liquid ; comme le
     tri est stable et qu'elles portent generalement un nombre, verifier
     le rendu si vous combinez `epingler` et tri numerique sur la meme
     facette.
     ============================================================ */

  function valeurNumerique(txt) {
    if (!txt) return null;
    /* colle les separateurs de milliers : "1 000" -> "1000" */
    var nettoye = txt.replace(/[\s\u00A0\u202F]+(?=\d)/g, '');
    var m = nettoye.match(/-?\d+(?:[.,]\d+)?/);
    if (!m) return null;
    var n = parseFloat(m[0].replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  /* Le "Voir plus" est calcule par Liquid sur l'ordre d'origine : apres
     reordonnancement, les classes sl-extra ne sont plus sur les bonnes
     lignes. On les repose selon le nouvel ordre. */
  function recalculerVoirPlus(group, lignes) {
    var seuil = parseInt(group.getAttribute('data-sl-seuil'), 10);
    if (!seuil || lignes.length <= seuil) return;

    lignes.forEach(function (el, i) {
      el.classList.toggle('sl-extra', i + 1 > seuil);
    });

    var btn = group.querySelector('.sl-facet__more');
    if (btn) {
      var libelle = '+ Voir ' + (lignes.length - seuil) + ' de plus';
      btn.setAttribute('data-more', libelle);
      if (!group.hasAttribute('data-expanded')) btn.textContent = libelle;
    }
  }

  function trierGroupe(group) {
    if (group.getAttribute('data-sl-tri') !== 'numerique') return;

    var conteneur = group.querySelector('.sl-checks, .sl-pills, .sl-swatches');
    if (!conteneur) return;
    /* deja trie : on evite de repayer un reflow a chaque mutation du DOM */
    if (conteneur.getAttribute('data-sl-trie') === '1') return;

    var lignes = Array.prototype.slice.call(conteneur.querySelectorAll('[data-sl-value]'));
    if (lignes.length < 2) {
      conteneur.setAttribute('data-sl-trie', '1');
      return;
    }

    var decorees = lignes.map(function (el, i) {
      return { el: el, i: i, n: valeurNumerique(el.getAttribute('data-sl-value')) };
    });

    decorees.sort(function (a, b) {
      if (a.n === null && b.n === null) return a.i - b.i;
      if (a.n === null) return 1;   /* non numeriques a la fin */
      if (b.n === null) return -1;
      if (a.n !== b.n) return a.n - b.n;
      return a.i - b.i;             /* stable */
    });

    var frag = document.createDocumentFragment();
    decorees.forEach(function (d) { frag.appendChild(d.el); });
    conteneur.appendChild(frag);
    conteneur.setAttribute('data-sl-trie', '1');

    recalculerVoirPlus(group, decorees.map(function (d) { return d.el; }));
  }

  function trierTout() {
    document.querySelectorAll('.sl-facets .sl-facet[data-sl-tri="numerique"]').forEach(trierGroupe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trierTout);
  } else {
    trierTout();
  }

  /* Le theme remplace le contenu de #facet-filters a chaque filtrage. On
     observe cet element precis et non tout le document : l'element
     conteneur, lui, persiste (seul son innerHTML change), et on evite de
     reagir a chaque mutation de la page — notamment au remplacement de la
     grille produits, qui est de loin la plus grosse. */
  var attenteTri = null;
  function surveillerTri() {
    var cible = document.querySelector('#facet-filters');
    if (!cible) return false;
    new MutationObserver(function () {
      if (attenteTri) return;
      attenteTri = setTimeout(function () {
        attenteTri = null;
        trierTout();
      }, 40);
    }).observe(cible, { childList: true, subtree: true });
    return true;
  }

  if (!surveillerTri()) {
    document.addEventListener('DOMContentLoaded', surveillerTri);
  }

  /* ============================================================
     Correctif — re-render de la sidebar de facettes
     ------------------------------------------------------------
     ProductFacet._rerender (theme.js) preserve les groupes ouverts en
     cherchant, pour chaque toggle de l'ANCIEN DOM, son homologue dans le
     NOUVEAU HTML :

         const t = filtersTempDiv.querySelector(`[aria-controls="..."]`);
         t.setAttribute("aria-expanded", ...)      // TypeError si t === null
         ...
         this.querySelector("#facet-filters").innerHTML = ...  // jamais atteint

     Or Search & Discovery retire un filtre de collection.filters des qu'il
     n'a plus de valeur pour la selection courante. Le toggle disparait donc
     du nouveau HTML, querySelector renvoie null, et l'exception interrompt
     la fonction AVANT le remplacement de la sidebar : la grille se met a
     jour mais les filtres restent figes (badges, "Filtres actifs" et
     compteurs perimes). Le bug se declenche surtout sur les selections
     restrictives, la ou beaucoup de filtres disparaissent d'un coup.

     On reimplemente la methode a l'identique, avec un garde sur le toggle
     manquant. Le patch porte sur le prototype : il s'applique aussi aux
     instances deja creees.
     ============================================================ */
  /* ------------------------------------------------------------
     Cache memoire des rendus de section.
     Cocher puis decocher un filtre est le geste le plus courant : sans
     cache, le retour en arriere repaye un aller-retour reseau complet.
     TTL court et taille bornee — il s'agit d'accelerer une session de
     navigation, pas de servir des donnees perimees (stock, prix).
     ------------------------------------------------------------ */
  var CACHE = new Map();
  var CACHE_TTL = 60000;   /* 1 min */
  var CACHE_MAX = 24;

  function cacheLire(cle) {
    var e = CACHE.get(cle);
    if (!e) return null;
    if (Date.now() - e.t > CACHE_TTL) { CACHE.delete(cle); return null; }
    /* remet l'entree en tete (LRU) */
    CACHE.delete(cle); CACHE.set(cle, e);
    return e.html;
  }

  function cacheEcrire(cle, html) {
    if (CACHE.size >= CACHE_MAX) CACHE.delete(CACHE.keys().next().value);
    CACHE.set(cle, { t: Date.now(), html: html });
  }

  function urlSection(href, sectionId) {
    var u = new URL(href, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  customElements.whenDefined('product-facet').then(function () {
    var PF = customElements.get('product-facet');
    if (!PF || PF.prototype.__slRerenderPatched) return;
    PF.prototype.__slRerenderPatched = true;

    /* Applique un rendu de section deja recupere. */
    PF.prototype.__slAppliquer = function (html) {
      var fakeDiv = document.createElement('div');
      fakeDiv.innerHTML = html;

      var nouveauMain = fakeDiv.querySelector('#facet-main');
      if (nouveauMain) this.querySelector('#facet-main').innerHTML = nouveauMain.innerHTML;

      var actifs = Array.from(fakeDiv.querySelectorAll('.product-facet__active-list'));
      var toolbarItem = document.querySelector('.mobile-toolbar__item--filters');
      if (toolbarItem) toolbarItem.classList.toggle('has-filters', actifs.length > 0);

      var filtersTempDiv = fakeDiv.querySelector('#facet-filters');
      if (filtersTempDiv) {
        var contenu = this.querySelector('#facet-filters .drawer__content');
        var scrollPrecedent = contenu ? contenu.scrollTop : 0;

        Array.from(this.querySelectorAll('#facet-filters-form .collapsible-toggle[aria-controls]'))
          .forEach(function (filterToggle) {
            var cle = filterToggle.getAttribute('aria-controls');
            var jumeau = filtersTempDiv.querySelector('[aria-controls="' + cle + '"]');
            /* le filtre a disparu du nouveau HTML : on passe, sinon le
               remplacement de la sidebar n'a jamais lieu (bug du theme) */
            if (!jumeau) return;
            var ouvert = filterToggle.getAttribute('aria-expanded') === 'true';
            jumeau.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
            var panneau = jumeau.nextElementSibling;
            if (!panneau) return;
            panneau.toggleAttribute('open', ouvert);
            panneau.style.overflow = ouvert ? 'visible' : '';
          });

        this.querySelector('#facet-filters').innerHTML = filtersTempDiv.innerHTML;

        var nouveauContenu = this.querySelector('#facet-filters .drawer__content');
        if (nouveauContenu) nouveauContenu.scrollTop = scrollPrecedent;
      }

      var cible = this.querySelector('.product-facet__meta-bar')
        || this.querySelector('.product-facet__product-list')
        || this.querySelector('.product-facet__main');
      if (cible) {
        requestAnimationFrame(function () {
          cible.scrollIntoView({ block: 'start', behavior: 'smooth' });
        });
      }
    };

    PF.prototype.__slFin = function () {
      this.classList.remove('sl-loading');
      this.hideLoadingBar();
    };

    PF.prototype.__slCharger = async function (cleUrl) {
      var html = cacheLire(cleUrl);
      if (html) { this.__slAppliquer(html); this.__slFin(); return; }

      this._abort();
      try {
        this.abortController = new AbortController();
        var reponse = await fetch(cleUrl, { signal: this.abortController.signal });
        var texte = await reponse.text();
        cacheEcrire(cleUrl, texte);
        this.__slAppliquer(texte);
        this.__slFin();
      } catch (e) {
        if (e.name === 'AbortError') return;   /* une requete plus recente a pris la main */
        console.error('[sl-facets] re-render des facettes :', e);
        this.__slFin();
      }
    };

    PF.prototype._rerender = function (event) {
      history.replaceState({}, '', event.detail.url);

      var cleUrl = urlSection(event.detail.url, this.getAttribute('section-id'));

      /* Deja en cache : on applique tout de suite, sans clignotement ni
         attente. C'est le cas du retour en arriere sur un filtre. */
      if (cacheLire(cleUrl)) {
        clearTimeout(this.__slTimer);
        this.__slCharger(cleUrl);
        return;
      }

      /* Feedback immediat, meme si la requete est differee : l'attente
         percue commence au clic, pas au depart du reseau. */
      this.classList.add('sl-loading');
      this.showLoadingBar();

      /* Debounce : cocher trois cases d'affilee ne doit declencher qu'une
         seule requete. Le theme annulait bien les precedentes, mais les
         emettait quand meme — bande passante et charge serveur pour rien. */
      var self = this;
      clearTimeout(this.__slTimer);
      this.__slTimer = setTimeout(function () { self.__slCharger(cleUrl); }, 180);
    };
  });

  /* ------------------------------------------------------------
     Prechargement au survol (desktop uniquement)
     ------------------------------------------------------------
     Sur un pointeur precis, survoler une valeur pendant 150 ms est un bon
     predicteur du clic. On recupere alors le rendu en avance : au clic,
     le cache repond et l'affichage est instantane.
     Volontairement desactive au toucher (pas de survol, et donnees
     mobiles a menager).
     ------------------------------------------------------------ */
  if (window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
    var minuteurPrefetch = null;
    var prefetchEnCours = false;

    /* Reconstruit l'URL qui resulterait d'un clic sur cette valeur, en
       repartant de l'etat courant du formulaire. */
    function urlApresClic(input) {
      var form = document.querySelector('#facet-filters-form');
      if (!form) return null;
      var params = new URLSearchParams();
      Array.from(form.elements).forEach(function (el) {
        if (!el.name) return;
        if (el.type === 'checkbox') {
          var coche = el === input ? !el.checked : el.checked;
          if (coche) params.append(el.name, el.value);
        } else if (el.value) {
          params.append(el.name, el.value);
        }
      });
      return window.location.pathname + '?' + params.toString();
    }

    document.addEventListener('mouseover', function (e) {
      var ligne = e.target.closest('.sl-facets [data-sl-value]');
      if (!ligne) return;
      var input = ligne.querySelector('input[type="checkbox"]');
      var facet = document.querySelector('product-facet[section-id]');
      if (!input || !facet || prefetchEnCours) return;

      clearTimeout(minuteurPrefetch);
      minuteurPrefetch = setTimeout(function () {
        var href = urlApresClic(input);
        if (!href) return;
        var cle = urlSection(href, facet.getAttribute('section-id'));
        if (cacheLire(cle)) return;
        prefetchEnCours = true;
        fetch(cle, { priority: 'low' })
          .then(function (r) { return r.text(); })
          .then(function (html) { cacheEcrire(cle, html); })
          .catch(function () { /* prechargement : un echec est sans consequence */ })
          .finally(function () { prefetchEnCours = false; });
      }, 150);
    });

    document.addEventListener('mouseout', function () {
      clearTimeout(minuteurPrefetch);
    });
  }

  /* ============================================================
     Raccourci "Afficher les promos"
     ------------------------------------------------------------
     Coche (ou decoche) d'un coup toutes les valeurs de la facette remise.
     Point d'attention : chaque `change` declenche un re-render complet cote
     theme. On modifie donc les cases SANS evenement, puis on n'en dispatche
     qu'un seul a la fin — sinon quatre paliers = quatre requetes.
     ============================================================ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sl-promos]');
    if (!btn) return;

    var racine = btn.closest('.sl-facets');
    if (!racine) return;

    var groupe = racine.querySelector('.sl-facet[data-sl-facet*="remise"]');
    if (!groupe) return;

    var cases = Array.prototype.slice.call(groupe.querySelectorAll('input[type="checkbox"]'));
    if (!cases.length) return;

    var activer = btn.getAttribute('aria-pressed') !== 'true';
    btn.setAttribute('aria-pressed', activer ? 'true' : 'false');
    btn.closest('.sl-promos').classList.toggle('is-active', activer);

    cases.forEach(function (c) { c.checked = activer; });

    /* Les paliers ne servent qu'une fois les promos filtrees : on deplie le
       groupe a l'activation pour permettre d'affiner dans la foulee.
       `collapsible-content` expose un setter `open` (custom element du theme).
       Apres le re-render AJAX, le Liquid rouvre de lui-meme tout groupe
       portant un filtre actif : l'etat reste coherent. */
    var panneau = groupe.querySelector('collapsible-content');
    if (panneau) panneau.open = activer;
    var entete = groupe.querySelector('.sl-facet__toggle[aria-controls]');
    if (entete) entete.setAttribute('aria-expanded', activer ? 'true' : 'false');

    /* un seul evenement : le theme relit tout le formulaire */
    cases[0].dispatchEvent(new Event('change', { bubbles: true }));

    push({
      event: 'facet_promos',
      facet_collection: collectionHandle(btn),
      facet_action: activer ? 'add' : 'remove'
    });
  });

  /* ---------- Voir plus / Voir moins ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sl-facet__more');
    if (!btn) return;

    var group = btn.closest('.sl-facet');
    if (!group) return;

    var expanded = group.hasAttribute('data-expanded');
    if (expanded) {
      group.removeAttribute('data-expanded');
      btn.textContent = btn.getAttribute('data-more');
    } else {
      group.setAttribute('data-expanded', '');
      btn.textContent = btn.getAttribute('data-less');
      push({
        event: 'facet_more',
        facet_collection: collectionHandle(btn),
        facet_group: groupKey(btn)
      });
    }
  });

  /* ---------- Recherche intra-facette ---------- */
  var searchTimer = null;

  document.addEventListener('input', function (e) {
    var input = e.target.closest('.sl-facet__search-input');
    if (!input) return;

    var group = input.closest('.sl-facet');
    if (!group) return;

    var q = input.value.trim().toLowerCase();

    /* pendant une recherche, le "voir plus" ne doit pas masquer un resultat */
    if (q) {
      group.setAttribute('data-expanded', '');
    }

    var visible = 0;
    group.querySelectorAll('[data-sl-value]').forEach(function (row) {
      var label = (row.getAttribute('data-sl-value') || '').toLowerCase();
      var hit = !q || label.indexOf(q) !== -1;
      row.style.display = hit ? '' : 'none';
      if (hit) visible++;
    });

    var empty = group.querySelector('.sl-facet__search-empty');
    if (empty) empty.hidden = !(q && visible === 0);

    var more = group.querySelector('.sl-facet__more');
    if (more) more.style.display = q ? 'none' : '';

    /* un seul event par recherche, pas un par frappe */
    clearTimeout(searchTimer);
    if (q.length >= 2) {
      searchTimer = setTimeout(function () {
        push({
          event: 'facet_search',
          facet_collection: collectionHandle(input),
          facet_group: groupKey(input),
          facet_query: q,
          facet_results: visible
        });
      }, 900);
    }
  });

  /* ---------- Etat visuel immediat ----------
     Le re-render AJAX repose la classe .is-active depuis Liquid, mais
     il y a un aller-retour reseau entre le clic et ce re-render. On
     synchronise ici pour que la coche reagisse a la milliseconde.
     Le CSS :has(input:checked) fait la meme chose sans JS ; ceci reste
     le filet pour les navigateurs sans :has(). */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!facetRoot(input) || input.type !== 'checkbox') return;

    var row = input.closest('[data-sl-value]');
    if (row) row.classList.toggle('is-active', input.checked);
  });

  /* ---------- GA4 : valeur de facette ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!facetRoot(input)) return;

    if (input.matches('.price-range input')) {
      push({
        event: 'facet_price',
        facet_collection: collectionHandle(input),
        facet_group: groupKey(input) || 'prix'
      });
      return;
    }

    if (input.type !== 'checkbox') return;

    var row = input.closest('[data-sl-value]');
    push({
      event: 'facet_click',
      facet_collection: collectionHandle(input),
      facet_group: groupKey(input),
      facet_value: row ? row.getAttribute('data-sl-value') : input.value,
      facet_action: input.checked ? 'add' : 'remove'
    });
  });

  /* ---------- GA4 : reset ---------- */
  document.addEventListener('click', function (e) {
    var groupReset = e.target.closest('.sl-facets [data-sl-reset]');
    if (groupReset) {
      push({
        event: 'facet_reset_group',
        facet_collection: collectionHandle(groupReset),
        facet_group: groupKey(groupReset)
      });
      return;
    }

    var clearAll = e.target.closest('.sl-facets [data-action="clear-filters"]');
    if (clearAll) {
      push({
        event: 'facet_clear',
        facet_collection: collectionHandle(clearAll)
      });
    }
  });

  /* ---------- GA4 : ouverture d'un groupe ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.sl-facets .sl-facet__toggle[aria-controls]');
    if (!toggle) return;
    /* on ne trace que l'ouverture, pas la fermeture */
    if (toggle.getAttribute('aria-expanded') === 'true') return;

    push({
      event: 'facet_open',
      facet_collection: collectionHandle(toggle),
      facet_group: groupKey(toggle)
    });
  });

  /* ---------- Ouverture du drawer mobile ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sl-filter-btn');
    if (!btn) return;
    push({
      event: 'facet_drawer_open',
      facet_collection:
        (document.querySelector('facet-filters.sl-facets') || {}).dataset
          ? document.querySelector('facet-filters.sl-facets').dataset.collection
          : ''
    });
  });
})();

/* Sync du bouton "Voir les résultats (n)" du drawer avec le compteur filtré.
   Focal re-render la grille + la meta-bar à chaque filtre, mais pas notre
   bouton custom du footer : on recopie le nombre depuis la meta-bar. */
(function () {
  var BTN   = '#facet-filters .drawer__footer button';
  var COUNT = '.shopify-section--main-collection .product-facet__meta-bar-item--count';

  function sync() {
    var c = document.querySelector(COUNT);
    var b = document.querySelector(BTN);
    if (!c || !b) return;
    var n = (c.textContent.match(/\d[\d\s\u00a0\u202f.,]*/) || [''])[0].replace(/\D/g, '');
    if (n) b.textContent = 'Voir les résultats (' + n + ')';
  }

  function boot() {
    sync();
    var scope = document.querySelector('#facet-main') || document.body;
    new MutationObserver(sync).observe(scope, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();